<template>
    <!-- BEGIN FOOTER -->
    <div class="footer-wrapper">
        <div class="footer-section f-section-1">
        </div>
        <div class="footer-section f-section-2">
            <p class="">
              <Link :href="route('changelog')" class="me-2">{{ usePage().props.app_version }}</Link>
                Created by <a href="https://sc-it.pl" class="link link-primary" target="_blank">SCIT</a> & <a href="https://askla.pl" class="link link-primary" target="_blank">ASKLA</a>
            </p>
        </div>
    </div>
    <!-- END FOOTER -->
</template>
<script setup>
import {usePage} from "@inertiajs/vue3";
</script>